import { render, staticRenderFns } from "./productpage.vue?vue&type=template&id=e432ad22"
import script from "./productpage.vue?vue&type=script&lang=js"
export * from "./productpage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports